import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { Project } from '../../../project/models/project';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormValidationService } from '../../../../shared/services/form-validation.service';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-project-create',
  template: require('./project-create.component.html'),
  styles: [require('./project-create.component.sass')]
})
export class ProjectCreateComponent implements OnInit {

  @ViewChild('projectCreateModal') projectCreateModal: ElementRef;
  
  @Input() existingProjects: Project[];
  @Output() createProject = new EventEmitter<Project>();

  projectCreateModalReference: NgbModalRef;
  newProject: Project;
  projectForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    public formValidation: FormValidationService
  ) {
    this.projectForm = this.fb.group({
      id: ["", [Validators.required, Validators.pattern(/^[0-9]\d{0,3}$/)]],
      name: ['', Validators.required],
      abbreviation: ['', Validators.required],
      region: [''],
    })
  }

  ngOnInit(): void {
  }

  async showModal() {
    this.projectForm.reset();
    this.projectCreateModalReference = await this.modalService.open(this.projectCreateModal, {
      size: 'lg',
      backdrop: 'static'
    });
  }

  create = () => {
    if (this.projectForm.valid) {
      this.createProject.emit({
        id: this.projectForm.value && this.projectForm.value.id,
        name: this.projectForm.value && this.projectForm.value.name,
        abbreviation: this.projectForm.value && this.projectForm.value.abbreviation,
        region: this.projectForm.value && this.projectForm.value.region,
          }
      );
      this.projectCreateModalReference.close();
      console.log(this.projectForm)
    }
    else{
      this.formValidation.validateAllFormFields(this.projectForm);
    }
  }


}
